const API_URL =
  process.env.VITE_API_URL || process.env.REACT_APP_PLAN_API || "";

export async function fetchPlans() {
  const response = await fetch(`${API_URL}/api/v1/plans`);

  if (!response.ok) {
    throw new Error(
      "Unable to load plans right now. Please try again shortly.",
    );
  }

  const data = await response.json();

  if (Array.isArray(data?.data?.plans)) {
    return data.data.plans;
  }

  throw new Error("Unable to read plan details. Please try again shortly.");
}

export async function createCheckout(planId, billingCycle = "monthly") {
  const token = localStorage.getItem("token"); // use your real token key

  if (!token) {
    throw new Error("Please log in to continue with checkout.");
  }

  const response = await fetch(`${API_URL}/api/subscription/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      plan_id: planId,
      billing_cycle: billingCycle,
    }),
  });

  const data = await response.json();

  if (response.status === 401) {
    throw new Error("Please log in to continue with checkout.");
  }

  if (!response.ok || data?.error) {
    throw new Error(data?.message || "Unable to start checkout.");
  }

  const checkoutUrl = data?.data?.checkout_url;

  if (!checkoutUrl) {
    throw new Error("Checkout URL missing from server response.");
  }

  const parsedUrl = new URL(checkoutUrl);
  const transactionId = parsedUrl.searchParams.get("_ptxn");

  if (!transactionId) {
    throw new Error("Checkout transaction ID missing from server response.");
  }

  return {
    checkoutUrl,
    transactionId,
  };
}

function getTransactionIdFromCheckoutUrl(checkoutUrl) {
  if (!checkoutUrl) {
    return "";
  }

  try {
    const parsedUrl = new URL(checkoutUrl);
    return parsedUrl.searchParams.get("_ptxn") || "";
  } catch (error) {
    return "";
  }
}
